var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('applicationForm',{attrs:{"applicationEditId":_vm.applicationId,"applicationDetail":_vm.applicationDetail,"formType":_vm.formType,"isEdit":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }